// Configuration centrale du module — Design System PROGÈRE V3.
// Un seul fichier source de vérité : ne jamais réécrire le nom du module ailleurs.
export const PROGERE_MODULE = {
  code: "crm",
  name: "CRM",
  fullName: "PROGÈRE CRM",
  subtitle: "Développez et automatisez vos relations clients",
  icon: "Users",
  domain: "https://crm.progere.ca",
  ecosystemSubtitle: "MODULE DE L'ÉCOSYSTÈME PROGÈRE",
};
